module.exports = __webpack_public_path__ + "9b08e971ddd13245a2d174896cf9551b.png";